import {uuid} from "./utils/uuid";

const defaultOptions = {
  context: ""
};

const getTopic = (topic, options = defaultOptions) => {
  const {context} = options;

  return context ? `${context}-${topic}` : topic;
};

class Subscriptions {
  constructor() {
    this.subscriptions = {};

    this.debug = false;
  }

  subscribe(topic, fn, options = defaultOptions) {
    const contextTopic = getTopic(topic, options),
      id = uuid();

    if (!this.subscriptions[contextTopic]) {
      this.subscriptions[contextTopic] = {};
    }

    this.subscriptions[contextTopic][id] = fn;

    return id;
  }

  unsubscribe(topic, fn, options = defaultOptions) {
    const contextTopic = getTopic(topic, options);

    // Assume we are unsubscribing by id
    if (!fn) {
      const topics = Object.values(this.subscriptions);

      topics.forEach(t => {
        delete t[topic];
      });

      return;
    }

    // Otherwise, assume we're unsubscribing with a function pointer
    if (!this.subscriptions[contextTopic]) {
      return;
    }

    const subTopic = this.subscriptions[contextTopic],
      toRemove = [];

    for (const [key, value] of Object.entries(subTopic)) {
      if (value === fn) {
        toRemove.push(key);
      }
    }

    toRemove.forEach(id => {
      delete subTopic[id];
    });
  }

  publish(topic, newValue, oldValue, options = defaultOptions) {
    const contextTopic = getTopic(topic, options);

    if (!this.subscriptions[contextTopic]) {
      return;
    }

    const fns = Object.values(this.subscriptions[contextTopic]);

    let debug;

    if (this.debug) {
      let stack = new Error().stack || "";
      stack = stack.split("\n").map(function(line) {
        return line.trim();
      });
      stack = stack.splice(stack[0] == "Error" ? 2 : 1);

      debug = {topic, stack};
    }

    fns.forEach(fn => {
      fn(newValue, oldValue, debug);
    });
  }
}

const Controller = () => {
  if (!window.atsSubscriptions) {
    window.atsSubscriptions = new Subscriptions();
  }

  return window.atsSubscriptions;
};

export default Controller();
